import { PlaybookStatus } from '@driftt/api-types'
import { A, Div, Tag } from '@driftt/tide-core'
import React from 'react'

import CollapsibleContent from 'components/CollapsibleContent'

import { HydratedPlaybookBlockData } from '.'

import styles from './styles.module.css'

interface CollapsibleArchivedListProps {
  archivedPlaybooks: HydratedPlaybookBlockData[]
  title: string
}

const CollapsibleArchivedList: React.ElementType<CollapsibleArchivedListProps> =
  ({ archivedPlaybooks, title }) => (
    <Div className={styles.archivedPbListContainer}>
      <CollapsibleContent title={title}>
        <Div className={styles.collapsibleArchivedPbList}>
          {archivedPlaybooks.map(({ playbook: pb, isOutdated }, index) => (
            <Div key={`archived-${index}`} className={styles.pbRow}>
              <Div className={styles.pbDetails}>
                <Tag
                  wrapperClass={styles.pbArchivedStatus}
                  type="default"
                  text={PlaybookStatus.ARCHIVED}
                />
                <A
                  href={`/playbooks/editor/${pb.id}/visual-builder`}
                  className={styles.pbName}
                  target="_blank"
                  rel="noreferrer"
                >
                  {pb.name}
                </A>
              </Div>
            </Div>
          ))}
        </Div>
      </CollapsibleContent>
    </Div>
  )

export default CollapsibleArchivedList
